export const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/

export function getFirstName(name: string) {
  return name.split(" ")[0]
}

export function isEmail(email: string) {
  return emailRegex.test(email)
}
